// extracted by mini-css-extract-plugin
module.exports = {"button":"_3f778b30","arrow":"_b263475f"};